











































































import { Component, Vue, Watch } from 'vue-property-decorator';
import CartHeader from '@/components/Commons/Header.vue';
import CartFooter from '@/components/Commons/Footer.vue';
import CartItem from '@/components/Cart/Item.vue';
import CartTotals from '@/components/Cart/Totals.vue';
import PromoCarousel from '@/components/Cart/PromoCarousel.vue';
import Coupon from '@/components/Cart/Coupon.vue';
import Clerk from '@/components/Commons/Clerk.vue';
import { CartItem as CartItemModel, Totals } from '@/store/models';
import cart from '@/store/modules/cart';
import CmsBlock from '@/components/Cms/Block.vue';
import GlamCardUse from '@/components/Cart/GlamCardUse.vue';
import GiftCard from '@/components/Cart/GiftCard.vue';
import user from '@/store/modules/user';
import gtmhelpers from '@/commons/gtmhelpers';
import store from '@/store';
import { debounce } from '@/commons/debounce';
import checkout from '@/store/modules/checkout';
import payment from '@/store/modules/payment';
import ui from '@/store/modules/ui';
import AlgoliaRecommend from '@/components/Cart/AlgoliaRecommend.vue';

// tutorial: il decorator Component dichiara la classe che segue come componente Vue.
// Possiamo passare l'oggetto components che saranno i componenti figli che potremo usare nel template
@Component({
  components: {
    CartHeader,
    CartFooter,
    CartItem,
    CartTotals,
    Coupon,
    CmsBlock,
    GlamCardUse,
    GiftCard,
    Clerk,
    PromoCarousel,
    AlgoliaRecommend,
  },
})
export default class Cart extends Vue {

  private mounted() {
    this.reloadKlarnaPlacement();
    ui.popSidebar();
  }

  get items(): CartItemModel[] {
    return cart.cart.items;
  }

  get itemIds(): string[] {
    return this.items.map((i) => (i.extension_attributes.extproduct_id.toString()))
  }

  get algoliaConfigs(): any {
    return store.state.options.algolia;
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get isFidelityUser(): boolean {
    return user.isFidelity;
  }

  get giftCardEnabled(): boolean {
    return store.state.options.payment.giftcard_enabled;
  }

  get count(): number  {
    return cart.cart.items.length;
  }

  get totals(): Totals {
    return cart.totals;
  }

  get grandTotal(): number  {
    return cart.totals.grand_total;
  }

  get baseGrandTotal(): number {
    return this.totals.base_grand_total;
  }

  get shouldShowBaseCurrency(): boolean {
    return this.totals.base_currency_code !== this.totals.quote_currency_code;
  }

  get isFidelityEnabled(): boolean {
    return store.state.options.fidelity.enabled;
  }

  get eurCurrencyConfigs(): any {
    return {
      decimalCount: 2,
      decimal: ',',
      thousands: '',
      sign: '€',
      signpos: 'after',
    };
  }

  get canUseDiscounts(): boolean {
    return !cart.isGiftcardCart;
  }

  get totalsIsLoading(): Totals {
    return cart.loadingFlags.totals;
  }

  get cartHasErrors(): boolean {
    return cart.cartHasError;
  }

  get isDevelop(): boolean {
    return (process.env.NODE_ENV === 'development') ? true : false;
  }

  get klarnaStatus(): boolean {
    return checkout.hasPaymentMethod('klarna_pay_later')
        && store.state.options.klarna_on_site_messages
        && store.state.options.klarna_on_site_messages.on_cart_enabled;
  }

  get klarnaLocale(): boolean {
    return checkout.hasPaymentMethod('klarna_pay_later')
        && store.state.options.klarna_on_site_messages
        && store.state.options.klarna_on_site_messages.locale;
  }

  @Watch('grandTotal')
  @debounce(1500)
  private reloadKlarnaPlacement() {
    this.$nextTick(() => { payment.callMethodApi({paymentMethod: 'klarna', apiMethod: 'loadPlacementApi'}); });
  }

  private trackBeginCheckout(){
    gtmhelpers.trackBeginCheckout(
        gtmhelpers.convertProductsData(this.items),
        cart.totals.grand_total,
        this.totals.quote_currency_code,
        checkout.coupon.coupon
    );
  }

  private proceed(to: string) {
    const route = '/login';
    if(to === "login"){
      this.trackBeginCheckout();
    }
    switch (to) {
      case 'back':
        window.history.go(-1);
        return;
      case 'guestlogin':
        cart.flagLoading({key: to, value: true});
        break;
      case 'guestregister':
        cart.flagLoading({key: to, value: true});
        ui.pushSidebar('register');
        break;
      default:
        cart.flagLoading({key: 'guestlogin', value: false});
        cart.flagLoading({key: 'guestregister', value: false});
    }
    // catch to suppress console error "Redirected when going from "/" to "/login" via a navigation guard"
    this.$router.push({path: route}).catch(() => { return; });
  }
}
